import { REACT_APP_ENV } from '../environments/environment';

export const isDevelopment = REACT_APP_ENV === 'development';
export const isProduction = REACT_APP_ENV === 'production';
